// Червеният маркер до клампнатото „Налично: 0" — „−10 продадени без наличност".
// Без минус не рендира нищо. Подсказката обяснява какво ще стане с минуса при
// доставка (минал ден — отписва се, същия ден — покрива се).
import { useTranslation } from "react-i18next";
import { formatQty } from "./qty";
import { soldWithoutStockOf } from "./negativeStock";

type Props = {
  quantity: number; // ЗНАКОВАТА наличност
  decimals: number;
  className?: string;
};

export const NegativeStockMarker = ({ quantity, decimals, className = "" }: Props) => {
  const { t } = useTranslation();
  const sold = soldWithoutStockOf(quantity);
  if (!sold) return null;
  return (
    <span title={t("inventoryPage.wsSoldWithoutStockHint")} className={`text-danger-ink ${className}`}>
      {t("inventoryPage.wsSoldWithoutStock", { qty: formatQty(sold, decimals) })}
    </span>
  );
};

export default NegativeStockMarker;
